module.exports = __webpack_public_path__ + "img/menu-Contact.24dabc4d.svg";